<template>
  <box style="max-width: 50rem;">
    <template v-slot:controls v-if="controls">
      <grab-control @grabstart="(e) => $emit('grabstart', e)" @grabend="(e) => $emit('grabend', e)"></grab-control>
      <kebab-menu>
        <action-link icon-left="icon-settings" size="small" class="mb-1" @click="$emit('configure')" v-if="editable">{{ $t('widgets.Dashboard.configure') }}</action-link>
        <action-link icon-left="icon-trash" size="small" @click="$emit('delete')">{{ $t('widgets.Dashboard.remove') }}</action-link>
      </kebab-menu>
    </template>

    <template v-slot:title>
      <div class="latest-orders__title text-color-space text--bold">{{$t('widgets.RegisteredUsers.title')}}</div>
    </template>

    <div class="registered-users">
      <div class="registered-users__filter d-flex">
        <v-button size="xs-small mr-1" :inactive="currTab !== 'currDate'" @click="currTab = 'currDate'">{{ $t('widgets.period.today') }}</v-button>
        <v-button size="xs-small mr-1" :inactive="currTab !== 'prevDate'" @click="currTab = 'prevDate'">{{ $t('widgets.period.yesterday') }}</v-button>
        <v-button size="xs-small mr-1" :inactive="currTab !== 'month'" @click="currTab = 'month'">{{ $t('widgets.period.month') }}</v-button>
      </div>
      <div class="registered-users__main mt-2">
        <div class="registered-users__item d-flex justify-space-between mt-1" v-for="(item, index) of computedStatsUsers" :key="index">
          <div class="registered-users__item-left">{{item.fio}}</div>
          <div class="registered-users__item-right text--bold">+{{item.phone}}</div>
        </div>
      </div>

      <v-button v-if="screen.breakPoint.tabPort" @click="$router.push({ name: 'referrals' })" width="full" class="mt-2">{{ $t('widgets.RegisteredUsers.goToSection') }}</v-button>
      <v-modal v-model="showReferrals" v-else>
        <template #activator="{ on }">
          <v-button @click="on" width="full" class="mt-2">{{ $t('widgets.RegisteredUsers.goToSection') }}</v-button>
        </template>

        <template #header>{{ $t('views.Referrals.title') }}</template>

        <referrals></referrals>
      </v-modal>
    </div>
  </box>
</template>

<script>
import KebabMenu from '@/ui/controls/KebabMenu'
import ActionLink from '@/ui/controls/ActionLink'
import GrabControl from '@/ui/controls/GrabControl'
import vButton from '@/ui/controls/vButton'
import vModal from '@/ui/modals/vModal'

import Referrals from '@/views/Dashboard/Referrals'

import Box from '@/ui/slots/Box'

import { StatsUsersGQL } from './queries'

import hasActiveContracts from '@/mixins/hasActiveContracts'

import screen from '@/mixins/screen'

let currTab = 'currDate'

export default {
  components: {
    vButton,
    Box,
    KebabMenu,
    ActionLink,
    GrabControl,
    vModal,
    Referrals
  },

  props: {
    editable: {
      type: Boolean,
      default: false
    },

    controls: {
      type: Boolean,
      default: false
    }
  },

  mixins: [hasActiveContracts, screen],

  apollo: {
    /**
     * @typedef StatisticsUser
     * @type {object}
     * @property {string} fio
     * @property {string} phone
     */
    /**
     * @typedef StatisticsUsersPeriod
     * @type {object}
     * @property {[StatisticsUser]} currDate
     * @property {[StatisticsUser]} month
     * @property {[StatisticsUser]} prevDate
     * @property {[StatisticsUser]} week
     */

    /**
     * @typedef DashboardUser
     * @type {object}
     * @property {number} countUsersPrevDate
     * @property {number} totalCountUsers
     * @property {StatisticsUsersPeriod} userStatistics
     */
    statsUsers: {
      query: StatsUsersGQL,
      update: data => data.merchant.stats.statsUsers,
      skip () { return !this.hasActiveContracts }
    }
  },

  data () {
    return {
      /**
       * @values currDate, month, prevDate
       */
      currTab: currTab,
      showReferrals: false
    }
  },

  watch: {
    currTab (val) {
      currTab = val
    }
  },

  computed: {
    computedStatsUsers () {
      if (!this.statsUsers) {
        return []
      }

      return this.statsUsers.userStatistics[this.currTab]
    }
  }
}
</script>

<style lang="scss">
  .registered-users {}
</style>
